import React from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock, Row, Col, Glyphicon } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FavLogo = ({ isLoading, logo, favicon, onRemoveFile, onChangeFileInput }) => {
  const prepareAcceptFileTypes = (types) => types?.map((type) => `.${type}`)?.join(',');

  return (
    <>
      {logo ? (
        <FormGroup>
          <Row>
            <Col md={10}>
              <FormGroup>
                <ControlLabel>{logo?.title}</ControlLabel>
                <FormControl
                  type={logo?.type}
                  accept={prepareAcceptFileTypes(logo?.types?.file)}
                  onChange={(e) => onChangeFileInput('logo', e)}
                  disabled={isLoading.logo}
                />
              </FormGroup>
              <HelpBlock>{logo?.info}</HelpBlock>
            </Col>
            <Col md={2}>
              <div className="settings-general-image">
                <div className="settings-general-image__container">
                  {isLoading.logo ? <div className="small-loader" /> : null}
                  {logo?.current ? (
                    <>
                      <img src={logo?.current} alt="Logo" />
                      {!isLoading.logo ? (
                        <div className="settings-general-image__remove" onClick={() => onRemoveFile('logo')}>
                          <Glyphicon glyph="remove" />
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
        </FormGroup>
      ) : null}
      {favicon ? (
        <FormGroup>
          <Row>
            <Col md={11}>
              <FormGroup>
                <ControlLabel>{favicon?.title}</ControlLabel>
                <FormControl
                  type={favicon?.type}
                  accept={prepareAcceptFileTypes(favicon?.types?.file)}
                  onChange={(e) => onChangeFileInput('favicon', e)}
                  disabled={isLoading.favicon}
                />
              </FormGroup>
              <HelpBlock>{favicon?.info}</HelpBlock>
            </Col>
            <Col md={1}>
              <div className="settings-general-image">
                <div className="settings-general-image__container">
                  {isLoading.favicon ? <div className="small-loader" /> : null}
                  {favicon?.current ? (
                    <>
                      <img src={favicon?.current} alt="Favicon" />
                      {!isLoading.favicon ? (
                        <div className="settings-general-image__remove" onClick={() => onRemoveFile('favicon')}>
                          <Glyphicon glyph="remove" />
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
        </FormGroup>
      ) : null}
      <hr />
    </>
  );
};

FavLogo.propTypes = {
  isLoading: PropTypes.object,
  logo: PropTypes.object,
  favicon: PropTypes.object,
  onRemoveFile: PropTypes.func,
  onChangeFileInput: PropTypes.func,
};

export default FavLogo;
